import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { PageHeader, Panel, MediaList } from "./ui";
import { useSettingsDraft } from "./settingsDraft";

const METHODS = [
  { k: "yape", l: "Yape" }, { k: "plin", l: "Plin" }, { k: "transferencia", l: "Transferencia bancaria" }, { k: "pago_entrega", l: "Pago contra entrega" },
];

export default function PaymentsPage() {
  const { d, setIn, SaveBtn } = useSettingsDraft();
  if (!d) return null;
  const p = d.payment || {};
  const set = (k, v) => setIn("payment", k, v);
  const accounts = p.accounts || [];
  const updAcc = (i, k, v) => set("accounts", accounts.map((a, j) => (j === i ? { ...a, [k]: v } : a)));
  return (
    <div data-testid="admin-payments-page">
      <PageHeader title="Pagos y métodos de pago" subtitle="Lo que configures aquí aparece en el checkout de la tienda" actions={SaveBtn} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Panel title="Métodos habilitados">
          <div className="space-y-3">
            {METHODS.map((m) => (
              <div key={m.k} className="flex items-center justify-between bg-neutral-50 rounded-xl px-4 py-3">
                <span className="font-semibold text-sm">{m.l}</span>
                <Switch checked={!!p.methods?.[m.k]} onCheckedChange={(v) => set("methods", { ...(p.methods || {}), [m.k]: v })} data-testid={`method-${m.k}`} />
              </div>
            ))}
          </div>
        </Panel>
        <Panel title="Billeteras digitales">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div><Label>Número de Yape</Label><Input value={p.yape || ""} onChange={(e) => set("yape", e.target.value)} data-testid="pay-yape-input" /></div>
            <div><Label>Número de Plin</Label><Input value={p.plin || ""} onChange={(e) => set("plin", e.target.value)} data-testid="pay-plin-input" /></div>
            <div className="sm:col-span-2"><Label>Nombre del titular</Label><Input value={p.holder || ""} onChange={(e) => set("holder", e.target.value)} data-testid="pay-holder-input" /></div>
          </div>
        </Panel>
        <Panel title="Cuentas bancarias">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div><Label>Banco principal</Label><Input value={p.bank || ""} onChange={(e) => set("bank", e.target.value)} /></div>
            <div><Label>N° de cuenta</Label><Input value={p.account || ""} onChange={(e) => set("account", e.target.value)} data-testid="pay-account-input" /></div>
            <div className="sm:col-span-2"><Label>CCI</Label><Input value={p.cci || ""} onChange={(e) => set("cci", e.target.value)} data-testid="pay-cci-input" /></div>
          </div>
          <div className="mt-5 space-y-3">
            <Label>Cuentas adicionales</Label>
            {accounts.map((a, i) => (
              <div key={i} className="grid grid-cols-12 gap-2 bg-neutral-50 rounded-xl p-2">
                <Input className="col-span-6 sm:col-span-3" placeholder="Banco" value={a.bank || ""} onChange={(e) => updAcc(i, "bank", e.target.value)} />
                <Input className="col-span-6 sm:col-span-4" placeholder="Cuenta" value={a.account || ""} onChange={(e) => updAcc(i, "account", e.target.value)} />
                <Input className="col-span-10 sm:col-span-4" placeholder="CCI" value={a.cci || ""} onChange={(e) => updAcc(i, "cci", e.target.value)} />
                <Button variant="outline" size="icon" className="col-span-2 sm:col-span-1" onClick={() => set("accounts", accounts.filter((_, j) => j !== i))}><Trash2 size={14} /></Button>
              </div>
            ))}
            <Button size="sm" variant="outline" onClick={() => set("accounts", [...accounts, { bank: "", account: "", cci: "" }])} data-testid="add-account"><Plus size={14} className="mr-1" /> Agregar cuenta</Button>
          </div>
        </Panel>
        <Panel title="Códigos QR y fotos de medios de pago">
          <MediaList value={p.qr_images || []} onChange={(v) => set("qr_images", v)} testid="pay-qr" />
        </Panel>
        <Panel title="Adelantos y condiciones" className="lg:col-span-2">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div><Label>Porcentaje de adelanto (%)</Label><Input type="number" min={0} max={100} value={p.advance_percent ?? 0} onChange={(e) => set("advance_percent", Number(e.target.value))} data-testid="pay-advance-input" /></div>
            <div className="sm:col-span-2"><Label>Condiciones de pago</Label><Textarea rows={2} value={p.conditions || ""} onChange={(e) => set("conditions", e.target.value)} data-testid="pay-conditions-input" /></div>
            <div className="sm:col-span-3"><Label>Instrucciones que verá el cliente</Label><Textarea rows={3} value={p.instructions || ""} onChange={(e) => set("instructions", e.target.value)} data-testid="pay-instructions-input" /></div>
          </div>
        </Panel>
      </div>
    </div>
  );
}
